
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'GERDGrading',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/GERDGrading.vue